import { ProjectClient, RelatedProjectIndicator } from "@/components/projects";
import { Divider } from "@msuite/ui/divider";
import { WorkspaceTag } from "@msuite/ui/tag";
import { getAddressString } from "@msuite/utils/strings";
import type { Nullable, NullableFields, ProjectCard, Tables } from "@msuite/utils/types";
import React from "react";
import { ProjectMembers } from "./project-members";
import { ProjectNote } from "./project-note";

/** Props Interface */
interface ProjectInformationProps {
	project?: Nullable<
		Omit<ProjectCard, "_tickets" | "createdAt" | "updatedAt"> & {
			createdAt: string | number | null;
			updatedAt: string | number | null;
		}
	>;
	members?: Array<Tables<"projectMembers"> & { _user: Tables<"users"> }>;
	client?: Nullable<NullableFields<Tables<"contacts">>>;
	withNote?: boolean;
	workspace?: Tables<"workspaces">;
}

export function ProjectInformation({
	project,
	members,
	client,
	workspace,
	withNote,
}: ProjectInformationProps) {
	if (!project) return null;

	/** Render */
	return (
		<React.Fragment>
			<div className="justify-between items-center h-stack">
				<WorkspaceTag workspace={workspace} />
				<p className="ml-auto text-primaryGray-500 text-sm">{project.number}</p>
			</div>
			<Divider variant="card" />
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 100px",
				}}
			>
				<div className="flex-9 gap-1 h-stack">
					<p className="max-w-[80%] font-semibold line-clamp-1">{project.name}</p>
					<RelatedProjectIndicator
						relatedProject={project._relatedProject}
						relatedProjectId={project.relatedProjectId}
					/>
				</div>
				{members && (
					<ProjectMembers
						members={members}
						justify="end"
					/>
				)}
			</div>
			<p className="text-primaryGray-700 dark:text-primaryGray-200">{getAddressString(project)}</p>
			<ProjectClient client={client} />
			{withNote && <ProjectNote note={project.note} />}
		</React.Fragment>
	);
}
